import React from "react";
import {ContentStylesColourBlock, ContentStylesDemoSubsection} from "../ContentStylesHelper";

const EDIT_TYPES = {
    TABLE_COLOUR: "cont-table-basic",
}

export const basicTableStylesRegistry = {
    [EDIT_TYPES.TABLE_COLOUR]: {title: 'Table color', cssVar: ["--cont-table-custom-colour", "--cont-table-custom-colour-RGB"]},
}

export const BasicTableStyles = props => {
    const {updateStylesCallback} = props;

    return (
        <>
            <ContentStylesColourBlock
                editType={EDIT_TYPES.TABLE_COLOUR}
                colourConfig={basicTableStylesRegistry[EDIT_TYPES.TABLE_COLOUR]}
                onChange={updateStylesCallback}
            />
        </>
    );
};

export const BasicTableDemo = props => {
    const {demoEvents} = props;

    return (
        <ContentStylesDemoSubsection>
            <table
                className={[
                    'cont-table',
                    EDIT_TYPES.TABLE_COLOUR
                ].filter(Boolean).join(" ")}
                {...demoEvents(EDIT_TYPES.TABLE_COLOUR)}
            >
                <thead>
                <tr>
                    <th scope='col'>First Name</th>
                    <th scope='col'>Last Name</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Bart</td>
                    <td>Simpson</td>
                </tr>
                </tbody>
            </table>
        </ContentStylesDemoSubsection>
    )
}